import React from 'react';
import { Space, Button, Input } from 'antd';
import { DeleteOutlined, SwapOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { DiffCell, CustomAttributesDiffCell } from '@components/shared/inventory/InventoryDiffCell';

export function getTransformationItemColumns(t, { onRemove, onNoteChange, attributeLabelByName } = {}) {
  const columns = [
    {
      title: t('models.product.name'),
      render: (_, r) => {
        const productId = r.inventory?.product?.id;
        const sku = r.inventory?.product?.sku;
        const name = r.inventory?.product?.name;
        if (!sku) return '-';
        const content = (
          <>
            <div>{sku}</div>
            {name && <div style={{ fontSize: 12, color: '#666' }}>{name}</div>}
          </>
        );
        return productId ? <Link to={`/products/${productId}`} target="_blank">{content}</Link> : content;
      },
    },
    {
      title: t('models.inventory.custom_attributes', { defaultValue: '自訂屬性' }),
      width: 200,
      render: (_, r) => (
        <CustomAttributesDiffCell
          source={r.inventory?.custom_attributes}
          target={r.target_custom_attributes}
          attributeLabelByName={attributeLabelByName}
        />
      ),
    },
    {
      title: t('models.shelf.location'),
      render: (_, r) => r.shelf?.shelf_location || r.shelf?.shelf_code || '-',
    },
    {
      title: t('models.inventory.inventory_type'),
      render: (_, r) => (
        <DiffCell
          source={r.inventory?.inventory_type?.name}
          target={r.target_inventory_type_name}
        />
      ),
    },
    {
      title: t('models.inventory.batch'),
      render: (_, r) => <DiffCell source={r.inventory?.batch} target={r.target_batch} />,
    },
    {
      title: t('models.inventory.manufacturing_date'),
      render: (_, r) => <DiffCell source={r.inventory?.manufacturing_date} target={r.target_manufacturing_date} />,
    },
    {
      title: t('models.inventory.expiration_date'),
      render: (_, r) => <DiffCell source={r.inventory?.expiration_date} target={r.target_expiration_date} />,
    },
    {
      title: t('models.inventory_transformation.quantity'),
      render: (_, r) => (
        <Space size={4}>
          <SwapOutlined style={{ color: '#1890ff' }} />
          <span style={{ color: '#1890ff', fontWeight: 'bold' }}>{Math.abs(r.quantity)}</span>
        </Space>
      ),
    },
    {
      title: t('models.stock_adjustment.reason'),
      render: (_, r) => r.reason_code ? t(`enums.stock_adjustment.reason_code.${r.reason_code}`, r.reason_code) : '-',
    },
    {
      title: t('models.stock_adjustment.note'),
      width: 200,
      render: (_, r, index) => onNoteChange ? (
        <Input
          value={r.note || ''}
          onChange={(e) => onNoteChange(index, e.target.value)}
          placeholder={t('models.stock_adjustment.note')}
          size="small"
        />
      ) : (r.note || '-'),
      ellipsis: !onNoteChange,
    },
  ];

  if (onRemove) {
    columns.push({
      title: t('common.actions'),
      width: 60,
      render: (_, _r, index) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onRemove(index)}
        />
      ),
    });
  }

  return columns;
}
